// extracted by mini-css-extract-plugin
export default {"popup_wrap":"createBankAccountComplite_popup_wrap__XBX1I","popup_message":"createBankAccountComplite_popup_message__1bvuT","content":"createBankAccountComplite_content__ENGFj"};